import { AllFoodType } from "model/food/types"

export const isFoodInfoChanged = (initFood: AllFoodType, food: AllFoodType) => {
  const isNameChanged = initFood.name !== food.name
  const isPortionChanged = initFood.portion !== food.portion
  const isUnitChanged = initFood.unit !== food.unit
  const isCalorieChanged = initFood.calorie !== food.calorie
  const isProteinChanged = initFood.protein !== food.protein
  const isFatChanged = initFood.fat !== food.fat
  const isCarbohydrateChanged = initFood.carbohydrate !== food.carbohydrate

  return (
    isNameChanged ||
    isPortionChanged ||
    isUnitChanged ||
    isCalorieChanged ||
    isProteinChanged ||
    isFatChanged ||
    isCarbohydrateChanged
  )
}
